import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import configFrontend from "../../../../../config/frontend";

import assets from "./assets";
import { format as dateFormat } from "date-fns";

import { de, enUS } from "date-fns/locale";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { utcToZonedTime } from "date-fns-tz";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import {
  getDateInZone,
  getTimeInZone,
} from "../../../../shared/utils/dateHelpers";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { globalAssets } from "../../../assets/global/assets";
import MirrorBarChart from "../../../../shared/components/MirrorBarChart";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const { t, i18n } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const lng = i18n?.language;

  const { options, fields, dynamic } = templateData;
  const color1 = getContentById("color1", options);
  const color2 = getContentById("color2", options);

  const headerEn = getContentById("headline-en", fields);
  const headerDe = getContentById("headline-de", fields);
  const textDe = getContentById("text-de", fields);
  const textEn = getContentById("text-en", fields);
  const openerType = getContentById("openerType", fields);

  const teamHome = _.get(dynamic, "assets.teamHome");
  const teamAway = _.get(dynamic, "assets.teamAway");
  const event = data?.event;
  // const nextGame = _.get(dynamic, "nextGame");
  const matchInfo = _.get(dynamic, "matchInfo");
  // const teamDataStyles = _.get(teamData, "styles", {});

  // const thisGameDateTmp = new Date(toIsoDateString(matchInfo?.date, matchInfo?.time)) || '';

  // const timeZone = 'Europe/Berlin';
  // const thisGameDate = utcToZonedTime(thisGameDateTmp, timeZone);

  const feedType = _.get(data, "event.feedType", "opta");

  const isValidDate = Boolean(matchInfo?.date);

  const isoMatchDate = toIsoDateString(matchInfo?.date, matchInfo?.time);
  const matchDate = matchInfo?.time
    ? new Date(isoMatchDate)
    : new Date(matchInfo?.date);
  const time = matchInfo?.time ? getTimeInZone(matchDate, lng, true) : "-:-";
  const date = matchInfo?.time ? getDateInZone(matchDate, lng) : "-";
  let competitionId = dynamic?.matchInfo?.competition?.id;

  if (feedType === "heimspiel") {
    competitionId = "olympic_2024";
  }

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];
  const goalData = _.get(dynamic, "goalData");
  const goals = _.get(dynamic, "goal");
  const maxAValue = Math.max(
    ...goalData?.flatMap(d => [d.teamA ?? 0])
  );
  const maxBValue = Math.max(
    ...goalData?.flatMap(d => [d.teamB ?? 0])
  );
  const maxValue = Math.max(
    ...goalData?.flatMap(d => [d.teamA ?? 0, d.teamB ?? 0])
  );
  const oneLineHeight = 250 / maxValue ?? 30;
  const firstHalfAValues = goalData?.slice(0, 9).flatMap(d => [d.teamA])
  const firstHalfBValues = goalData?.slice(0, 9).flatMap(d => [d.teamB])
  const secondHalfAValues = goalData?.slice(9).flatMap(d => [d.teamA])
  const secondHalfBValues = goalData?.slice(9).flatMap(d => [d.teamB])
  const homeGoals = goals?.filter((g) => (g.contestantId === homeTeam?.id && g.type !== "OG") || (g.contestantId !== homeTeam?.id && g.type === "OG"));
  const awayGoals = goals?.filter((g) => (g.contestantId === awayTeam?.id && g.type !== "OG") || (g.contestantId !== awayTeam?.id && g.type === "OG"));
  const firstHalfAGoals = homeGoals?.filter((g) => g.timeMin < 46);
  const firstHalfBGoals = awayGoals?.filter((g) => g.timeMin < 46);
  const secondHalfAGoals = homeGoals?.filter((g) => g.timeMin >= 46);
  const secondHalfBGoals = awayGoals?.filter((g) => g.timeMin >= 46);
  const liveData = _.get(dynamic, "liveData");
  const matchDetails = liveData?.matchDetails;
  const matchStatus = matchDetails?.matchStatus;
  const scores = matchDetails?.scores;

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className={"qatar-logo"}>
            <img src={globalAssets.of_logo} />
          </div>

          <MatchScoreWidget
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            scores={scores}
            matchStatus={matchStatus}
            matchDetails={matchDetails}
            competitionId={competitionId}
            matchInfo={matchInfo}
          />

          <div className={"main-header"}>
            {t("Momentum", { keyPrefix: "templates" })}
          </div>

          <div className="main-content">
            <div className="team-info-container">
              <div className={"team-logo-container home"}>
                <Image
                  className="team-logo"
                  src={getDynamicLogoPath({ team: homeTeam, competitionId })}
                />
              </div>
              <div className={"team-logo-container away"}>
                <Image
                  className="team-logo"
                  src={getDynamicLogoPath({ team: awayTeam, competitionId })}
                />
              </div>
            </div>
            <div className="goals-first-half-container">
              <div
                className="team-A-container"
                style={{}}
              >
                {
                  firstHalfAValues?.map((value) => {
                    const opacity = value / maxAValue;
                    return <div
                      data-height={value * oneLineHeight}
                      className="score-container team-A"
                      style={{
                        background: `rgba(201,0,37,${opacity})`,
                        height: value * oneLineHeight
                      }}>
                      <span>{value}</span>
                    </div>
                  })
                }
                {
                  firstHalfAGoals?.map((goal) => {
                    const pos = goal.timeMin / 5;
                    const posX = pos * 68;
                    return <div className="goal-container" style={{
                      left: 280 + posX
                    }}>
                      <img src={assets.goal_logo} />
                      <div className="goal-line" />
                    </div>
                  })
                }
              </div>
              <div className="time-series-container" style={{}}>
                <span>Kick Off</span>
                <div className="time-line first" />
                <div className="time-line" />
                <div className="time-line" />
                <span>45'</span>
              </div>
              <div
                className="team-B-container"
                style={{}}
              >
                {
                  firstHalfBValues?.map((value) => {
                    const opacity = value / maxBValue;
                    return <div
                      className="score-container team-A"
                      data-height={value * oneLineHeight}
                      style={{
                        background: `rgba(24, 204,251,${opacity})`,
                        height: value * oneLineHeight
                      }}>
                      <span>{value}</span>
                    </div>
                  })
                }
                {
                  firstHalfBGoals?.map((goal) => {
                    const pos = goal.timeMin / 5;
                    const posX = pos * 68;
                    return <div className="goal-container negative" style={{
                      left: 280 + posX
                    }}>
                      <div className="goal-line" />
                      <img src={assets.goal_logo} />
                    </div>
                  })
                }
              </div>
            </div>
            <div className="goals-second-half-container">
              <div
                className="team-A-container"
                style={{}}
              >
                {
                  secondHalfAValues?.map((value) => {
                    const opacity = value / maxAValue;
                    return <div
                      data-height={value * oneLineHeight}
                      className="score-container team-A"
                      style={{
                        background: `rgba(201,0,37,${opacity})`,
                        height: value * oneLineHeight
                      }}
                    >
                      <span>{value}</span>
                    </div>
                  })
                }
                {
                  secondHalfAGoals?.map((goal) => {
                    const pos = goal.timeMin / 5;
                    const posX = pos * 68;
                    return <div className="goal-container" style={{
                      left: 280 + 33 + posX
                    }}>
                      <img src={assets.goal_logo} />
                      <div className="goal-line" />
                    </div>
                  })
                }
              </div>
              <div className="time-series-container" style={{
              }}>
                <div className="time-line first" />
                <div className="time-line" />
                <div className="time-line" />
                <span>90'</span>
              </div>
              <div
                className="team-B-container"
                style={{}}
              >
                {
                  secondHalfBValues?.map((value) => {
                    const opacity = value / maxBValue;
                    return <div
                      data-height={value * oneLineHeight}
                      className="score-container team-A"
                      style={{
                        background: `rgba(24, 204,251,${opacity})`,
                        height: value * oneLineHeight
                      }}
                    >
                      <span>{value}</span>
                    </div>
                  })
                }
                {
                  secondHalfBGoals?.map((goal) => {
                    const pos = goal.timeMin / 5;
                    const posX = pos * 68;
                    return <div className="goal-container negative" style={{
                      left: 280 + 33 + posX
                    }}>
                      <div className="goal-line" />
                      <img src={assets.goal_logo} />
                    </div>
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
